import React, { createContext, useContext, useState } from "react";

const LeadContext = createContext(null);

export const useLead = () => useContext(LeadContext);

export const LeadProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaults, setDefaults] = useState({});

  const openLead = (presets = {}) => {
    setDefaults(presets);
    setOpen(true);
  };

  return (
    <LeadContext.Provider value={{ open, setOpen, openLead, defaults }}>
      {children}
    </LeadContext.Provider>
  );
};
